export default __webpack_public_path__ + "static/media/box.91ef9892.svg";